import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    imc: [],
  },

  getters: {
    getImc: (state) => state.imc,
  },

  mutations: {
    SET_IMC(state, imc) {
      state.imc = imc;
    },
  },

  actions: {
    async fetchImc({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catImc')
        .then((response) => {
          commit('SET_IMC', response.data.data);
        });
    },
  },
};
